/*
const SET_LANGUAGE = (state, lang) => {
    state.language = lang;
}
*/

const SET_SORTBY = (state, type) => {
  state.sortby = type;
};

const SET_WRAPSIZE = (state, size) => {
  state.wrapperSize = size;
};

const SET_ENABLESOUND = (state, mode) => {
  state.enableSound = mode;
};

const SET_SESSIONEXPIRED = (state) => {
  state.sessionExpired = true;
};

export default {
  // SET_LANGUAGE,
  SET_SORTBY,
  SET_WRAPSIZE,
  SET_ENABLESOUND,
  SET_SESSIONEXPIRED,
};
